<app-main-layout>
  <app-championship-view-page></app-championship-view-page>
</app-main-layout>
